/* eslint-disable class-methods-use-this */
import { safeCallback } from '../func_arr';
/** An empty backend implementation */
export class EmptyComposedBackendContext {
    constructor() {
        this.mode = 2 /* BackendMode.Composed */;
        this._$styleSheetIdInc = 1;
        this._$renderCallbacks = null;
        this._$rootNode = new EmptyComposedBackendElement();
    }
    destroy() {
        // empty
    }
    getWindowWidth() {
        return 1;
    }
    getWindowHeight() {
        return 1;
    }
    getDevicePixelRatio() {
        return 1;
    }
    getTheme() {
        return 'light';
    }
    registerStyleSheetContent(_path, _content) {
        // empty
    }
    appendStyleSheetPath(_path, _styleScope) {
        const id = this._$styleSheetIdInc;
        this._$styleSheetIdInc += 1;
        return id;
    }
    disableStyleSheet(_index) {
        // empty
    }
    render(cb) {
        if (this._$renderCallbacks) {
            this._$renderCallbacks.push(cb);
        }
        else {
            const callbacks = (this._$renderCallbacks = [cb]);
            setTimeout(() => {
                this._$renderCallbacks = null;
                callbacks.forEach((cb) => {
                    safeCallback('Render Callback', cb, this, [null]);
                });
            }, 16);
        }
    }
    getRootNode() {
        return this._$rootNode;
    }
    createElement(_tagName, _stylingName) {
        return new EmptyComposedBackendElement();
    }
    createTextNode(_tagName) {
        return new EmptyComposedBackendElement();
    }
    createFragment() {
        return new EmptyComposedBackendElement();
    }
    onEvent(_listener) {
        // empty
    }
    createMediaQueryObserver(_status, _listener) {
        return {
            disconnect: () => {
                /* empty */
            },
        };
    }
}
/** An element for empty backend implementation */
export class EmptyComposedBackendElement {
    release() {
        // empty
    }
    associateValue(_v) {
        // empty
    }
    appendChild(_child) {
        // empty
    }
    removeChild(_child, _index) {
        // empty
    }
    insertBefore(_child, _before, _index) {
        // empty
    }
    replaceChild(_child, _oldChild, _index) {
        // empty
    }
    spliceBefore(_before, _deleteCount, _list) {
        // empty
    }
    spliceAppend(_list) {
        // empty
    }
    spliceRemove(_before, _deleteCount) {
        // empty
    }
    setId(_id) {
        // empty
    }
    setStyleScope(_styleScope, _extraStyleScope, _hostStyleScope) {
        // empty
    }
    setStyle(_styleText) {
        // empty
    }
    addClass(_elementClass, _styleScope) {
        // empty
    }
    removeClass(_elementClass, _styleScope) {
        // empty
    }
    clearClasses() {
        // empty
    }
    setAttribute(_name, _value) {
        // empty
    }
    removeAttribute(_name) {
        // empty
    }
    setText(_content) {
        // empty
    }
    getBoundingClientRect(cb) {
        setTimeout(() => {
            cb({
                left: 0,
                top: 0,
                width: 0,
                height: 0,
            });
        }, 0);
    }
    getScrollOffset(cb) {
        setTimeout(() => {
            cb({
                scrollLeft: 0,
                scrollTop: 0,
                scrollWidth: 0,
                scrollHeight: 0,
            });
        }, 0);
    }
    setListenerStats(_type, _capture, _mutLevel) {
        // empty
    }
    setModelBindingStat(_attributeName, _listener) {
        // empty
    }
    createIntersectionObserver(_relativeElement, _relativeElementMargin, _thresholds, _listener) {
        return {
            disconnect: () => {
                /* empty */
            },
        };
    }
    getContext(cb) {
        cb(null);
    }
}
//# sourceMappingURL=empty_composed_backend.js.map